'use strict';

var UserManagementPanelConfig = function UserManagementPanelConfig($stateProvider) {
  $stateProvider.state('app.user-management', {
    url: '/workflow/user-management',
    params: {
      transitionData: null
    },
    views: {
      '': {
        template: require('../templates/user-management-panel.html'),
        controller: 'UserManagementPanelController'
      },
      'mainToolbar': {
        template: require('../templates/user-management-toolbar.html'),
        controller: 'UserManagementToolbarController'
      }
    }
  });
};
module.exports = UserManagementPanelConfig;
UserManagementPanelConfig.$inject = ['$stateProvider'];